module.exports = __webpack_public_path__ + "assets/img/dion.830ecd8a.jpg";